export default {
  start : "Connaissance G T1",
  end : "Connaissance G T2",
  //start : "multitache",
  //end : "prise d'initiative"
}
